<div class="read-only-field-container" [ngClass]="[containerCss]">
  <label [ngClass]="[labelCss]" *ngIf="label">{{ label }}</label>
  <div [ngClass]="valueContainerCss" class="display-flex align-items-center">
    <ng-container [ngTemplateOutlet]="customValue ? customValue : defaultValue"></ng-container>
  </div>
</div>

<ng-template #defaultValue>
  <ng-container *ngIf="hasFade; else withNoFade">
    <div class="fade-text body-small text-color dark">
      {{ value || emptyValue }}
    </div>
  </ng-container>
  <ng-template #withNoFade>
    <div [ngClass]="valueCss">
      {{ value || emptyValue }}
    </div>
  </ng-template>
</ng-template>
